import React, { useEffect, useRef, useState } from "react";
import { BrowserMultiFormatReader } from "@zxing/browser";
import toast from "react-hot-toast";

const stopVideoTracks = (videoEl) => {
  try {
    const stream = videoEl?.srcObject;
    if (stream) {
      const tracks = Array.from(stream.getTracks ? stream.getTracks() : []);
      tracks.forEach((t) => {
        try { t.stop(); } catch (e) {}
      });
      videoEl.srcObject = null;
    }
  } catch (e) {}
};

const BarcodeScannerComponent = ({ onScan, onClose }) => {
  const videoRef = useRef(null);
  const codeReaderRef = useRef(null);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    let mounted = true;

    const start = async () => {
      try {
        codeReaderRef.current = new BrowserMultiFormatReader();

        // ✅ Correct: call listVideoInputDevices as static method
        const devices = await BrowserMultiFormatReader.listVideoInputDevices();
        if (!mounted) return;

        if (!devices || devices.length === 0) {
          toast.error("No camera found on this device.");
          handleClose();
          return;
        }

        const backCamera = devices.find(d => /back|rear|environment/i.test(d.label)) || devices[0];
        const deviceId = backCamera.deviceId;

        codeReaderRef.current.decodeFromVideoDevice(
          deviceId,
          videoRef.current,
          (result, err) => {
            if (result) {
              const text = result.text.replace(/[^0-9]/g, "");
              if (text) {
                try { onScan(text); } catch (e) {}
                stopEverything();
              }
            }
          }
        );

        setStarted(true);
      } catch (err) {
        console.error("Barcode scanner start error:", err);
        toast.error("Unable to access camera. Please allow camera permission or use a supported browser.");
        handleClose();
      }
    };

    const stopEverything = () => {
      try {
        if (codeReaderRef.current?.reset) codeReaderRef.current.reset();
      } catch (e) {}
      if (videoRef.current) stopVideoTracks(videoRef.current);
      setStarted(false);
    };

    const handleClose = () => {
      stopEverything();
      if (onClose) onClose();
    };

    start();

    return () => {
      mounted = false;
      try {
        if (codeReaderRef.current?.reset) codeReaderRef.current.reset();
      } catch (e) {}
      if (videoRef.current) stopVideoTracks(videoRef.current);
    };
  }, [onScan, onClose]);

  const handleStop = () => {
    try {
      if (codeReaderRef.current?.reset) codeReaderRef.current.reset();
    } catch (e) {}
    if (videoRef.current) stopVideoTracks(videoRef.current);
    if (onClose) onClose();
  };

  return (
    <div className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-75 d-flex flex-column justify-content-center align-items-center" style={{ zIndex: 1050 }}>
      <video ref={videoRef} style={{ width: "90%", borderRadius: 10 }} muted playsInline />
      <div className="mt-3 d-flex gap-2">
        <button className="btn btn-danger" onClick={handleStop}>Stop</button>
      </div>
    </div>
  );
};

export default BarcodeScannerComponent;
